module.exports = __webpack_public_path__ + "img/italic-square.069185b4.svg";